import { useTranslation } from "react-i18next";
import { Award, Link2 } from "lucide-react";
import { StatCard, WalletHeroCard } from "@/components/common";
import { formatMoney } from "@/lib/money";
import type { SalesAgentDashboard } from "@/types";

interface SalesAgentDashboardStatsProps {
  data: SalesAgentDashboard;
}

export function SalesAgentDashboardStats({
  data,
}: SalesAgentDashboardStatsProps) {
  const { t } = useTranslation("dashboard");
  const isAmountOwed = data.wallet_balance_cents < 0;

  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 xl:grid-cols-4">
      <WalletHeroCard
        className="col-span-2"
        label={t(
          isAmountOwed ? "salesAgent.amountOwed" : "salesAgent.walletBalance",
        )}
        amount={formatMoney(Math.abs(data.wallet_balance_cents))}
        isAmountOwed={isAmountOwed}
        link={{ to: "/wallet", label: t("shared.wallet") }}
      />
      <StatCard
        title={t("salesAgent.lifetimeCredits")}
        value={formatMoney(data.total_credits_cents)}
        icon={Award}
        iconColor="accent"
      />
      <StatCard
        title={t("salesAgent.assignedScopes")}
        value={data.assigned_scopes_count}
        icon={Link2}
        iconColor="primary"
      />
    </div>
  );
}
